import {
    Button,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Text,
} from "@chakra-ui/react";
import { CheckIcon, ChevronDownIcon } from "@chakra-ui/icons";
import React, { useEffect, useState } from "react";

const MultiSelectDropdown = ({ options = [], value = [], onChange, disable = false }) => {
    const [selectedValues, setSelectedValues] = useState([]);

    useEffect(() => {
        setSelectedValues(value || []);
    }, [value]);

    const handleToggle = (val) => {
        let newValues;
        if (selectedValues.includes(val)) {
            newValues = selectedValues.filter((v) => v !== val);
        } else {
            newValues = [...selectedValues, val];
        }
        setSelectedValues(newValues);
        onChange && onChange(newValues);
    };

    const displayLabel =
        options
            .filter((option) => selectedValues.includes(option.value))
            .map((option) => option.label)
            .join(", ") || "Select Options";

    return (
        <Menu closeOnSelect={false}>
            <MenuButton disabled={disable} border="1px solid"
                borderColor="gray.300" as={Button} rightIcon={<ChevronDownIcon />} w="200px" textAlign="left">
                <Text noOfLines={1}>{displayLabel}</Text>
            </MenuButton>
            <MenuList maxH="200px" overflowY="auto">
                {options.map((option) => {
                    const isSelected = selectedValues.includes(option.value);
                    console.log("isSelected", isSelected)
                    return (
                        <MenuItem
                            className="multipleOption-label"
                            key={option.value}
                            onClick={() => handleToggle(option.value)}
                            closeOnSelect={false}
                            bg={isSelected ? "gray.200" : "transparent"}
                            _hover={{ bg: "gray.200" }}
                            borderRadius="0"
                            justifyContent={"space-between"}
                        >
                            <Text fontWeight={isSelected ? "semibold" : "normal"}>
                                {option.label}
                            </Text>
                            {isSelected && <CheckIcon boxSize={3} color={`var(--chakra-colors-tableTextColor)`} />}
                        </MenuItem>
                    );
                })}
            </MenuList>
        </Menu>
    );
};

export default MultiSelectDropdown;